import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaWordpress,
  FaPlug,
  FaShoppingCart,
  FaMobileAlt,
  FaShieldAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const WooCommerceWebsiteDevelopmentInBurDubai = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="WooCommerce Website Development in Bur Dubai" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Unlock the Power of WooCommerce</Subheading>}
        heading={
          <Heading>
            WooCommerce <span tw="text-primary-500">Website Development</span>{" "}
            in Bur Dubai
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer specialized WooCommerce website
            development services in **Bur Dubai**, building powerful, flexible,
            and scalable online stores using the WooCommerce platform. Transform
            your business with a WordPress-powered e-commerce solution.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1607082349566-187342175e2f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // WooCommerce store setup
          "https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce development
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online shopping experience
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Launch with WooCommerce"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert WooCommerce Development in Bur Dubai"
        description="We harness WooCommerce’s flexibility to deliver top-tier e-commerce solutions."
        cards={[
          {
            icon: <FaWordpress color="#ff5464" size={40} />,
            title: "WooCommerce Mastery",
            description:
              "Deep expertise in WordPress and WooCommerce integration.",
          },
          {
            icon: <FaPlug color="#ff5464" size={40} />,
            title: "Custom Plugins",
            description:
              "Tailored extensions to enhance your store’s functionality.",
          },
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Seamless Shopping",
            description: "User-friendly designs for higher conversions.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile Responsive",
            description: "Optimized for shopping on any device.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure Platform",
            description: "Robust security for safe transactions.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Results",
            description: "Proven success for Bur Dubai businesses.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our WooCommerce Development Process"
        description={
          <Description>
            We create WooCommerce stores with a structured, efficient approach:
            <ul tw="mt-4 list-disc pl-6">
              <li>Planning: Assess your needs and e-commerce goals.</li>
              <li>Design: Build custom, responsive WooCommerce themes.</li>
              <li>Development: Integrate plugins and features seamlessly.</li>
              <li>
                Testing: Ensure compatibility and performance across devices.
              </li>
              <li>Launch: Deploy your store with full optimization.</li>
              <li>Support: Offer ongoing maintenance and updates.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Development workflow
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Team collaboration
          "https://images.unsplash.com/photo-1517292987719-0369a794ec0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce analytics
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="WooCommerce Wins in Bur Dubai"
        description="Our WooCommerce solutions have delivered outstanding results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Sales Increase",
            description: "Grew a local store’s sales by 180% with WooCommerce.",
          },
          {
            icon: <FaPlug color="#ff5464" size={40} />,
            title: "Custom Features",
            description: "Added unique functionality, saving 15 hours weekly.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Approval",
            description: "96% satisfaction from WooCommerce clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Sell with WooCommerce?</Subheading>}
        heading="Your WooCommerce Store in Bur Dubai"
        description={
          <Description>
            Partner with MilaajBrandset for expert WooCommerce website
            development in Bur Dubai. Build a flexible, powerful online store
            that drives growth—let’s get started today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Dubai cityscape
          "https://images.unsplash.com/photo-1543286386-713bdd548da4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // E-commerce success
          "https://images.unsplash.com/photo-1577401239170-897942555fb3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", // Online store management
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
